/* Matapayals — Recently Viewed products.
   Product pages store their handle (inline script in main-product.liquid).
   This renders saved products into any [data-mp-recently-viewed] container by
   fetching each product's JSON. Device-based (localStorage), no app needed. */
(function () {
  'use strict';
  var KEY = 'mp_recently_viewed';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  function inr(cents) {
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function esc(s) { return (s || '').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function render() {
    var wrap = document.querySelector('[data-mp-recently-viewed]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-mp-rv-grid]');
    var empty = wrap.querySelector('[data-mp-rv-empty]');
    var exclude = wrap.getAttribute('data-exclude') || '';
    var limit = parseInt(wrap.getAttribute('data-limit') || '12', 10);

    var handles = get().filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    if (!handles.length) { if (empty) empty.hidden = false; return; }

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var imgUrl = img ? img.split('?')[0] + '?width=420' : '';
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        var a = document.createElement('a');
        a.className = 'mp-rv-card';
        a.href = '/products/' + p.handle;
        a.innerHTML =
          '<span class="mp-rv-card__img">' + (imgUrl ? '<img src="' + imgUrl + '" loading="lazy" alt="' + esc(p.title) + '">' : '') + (sale ? '<span class="mp-rv-card__badge">Sale</span>' : '') + '</span>' +
          '<span class="mp-rv-card__title">' + esc(p.title) + '</span>' +
          '<span class="mp-rv-card__price">' + inr(p.price) + (sale ? ' <s>' + inr(p.compare_at_price) + '</s>' : '') + '</span>';
        grid.appendChild(a);
      });
      if (grid.children.length) { if (empty) empty.hidden = true; }
      else if (empty) { empty.hidden = false; }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
